import { Outlet } from 'react-router';

import { Sidebar } from '@virtual-care/ui';

import { LanguageSwitcher } from '../i18n/language-switcher.tsx';
import { useSidebarData } from './navigation/sidebar-data.tsx';

export default function Layout() {
  const { mainSidebarItems, footerSidebarItems } = useSidebarData();

  return (
    <div className="min-h-screen pb-12 md:p-4 md:ps-24 md:pb-4">
      <Sidebar
        mainSidebarItems={mainSidebarItems}
        footerSidebarItems={footerSidebarItems}
      />
      <LanguageSwitcher
        variant="mobile"
        className="bg-sidebar-primary absolute inset-e-3 top-3 z-40 h-10 w-10 shadow-md md:hidden"
      />
      <div className="flex flex-1 flex-col gap-4 pt-0 pb-20 md:p-4">
        <Outlet />
      </div>
    </div>
  );
}
